import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  node: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '8px',
    '&:hover': {
      'background-color': theme.palette.action.hover,
      color: '#000',
      '& span': {
        color: '#000'
      },
      cursor: 'pointer'
    },
  },
  visited: {
    'background-color': theme.palette.action.selected,
  },
  selected: {
    'background-color': theme.palette.primary.main,
    color: '#fff',
    '& span': {
      color: '#fff'
    },
    '& .MuiButtonBase-root': {
      color: '#fff'
    },
    '&:hover': {
      'background-color': theme.palette.primary.main,
      color: '#fff',
      '& span': {
        color: '#fff'
      },
    },
  },
});
